<template>
    <div>
        <PageHeader :title="$t('widgeterShops.title')" :subtitle="$t('widgeterShops.subtitle')" />
        <Filters ref="Filters" />
        <Results ref="Results" />
        <ModalProductFeeds />
    </div>
</template>



<script>
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import Filters from './parts/Filters.vue';
    import Results from './parts/Results.vue';
    import ModalProductFeeds from './parts/ModalProductFeeds.vue';

    const DEFAULT_FILTERS_PARAMS = Object.freeze({
        spaceId: null,
        name: null,
        categories: [],
        statuses: [],
    });
    const DEFAULT_TABLE_PARAMS = Object.freeze({
        perPage: 25,
        page: 1,
        sort: 'id',
        order: 'DESC',
    });

    export default {
        name: 'Shops',
        mixins: [viewFiltersMixin],
        components: {
            Filters,
            Results,
            ModalProductFeeds,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('space/campaigns'),
            };
        },
        computed: {
            urlParams() {
                return { spaceId: this.filters.spaceId };
            },
        },
        methods: {
            fetchData(force = false) {
                if (!this.request || !this.filters.spaceId) return Promise.resolve(null);
                return this.request.get({ ...this.requestParams, ...this.urlParams, cache: !force });
            },
        },
    };
</script>
